import React, { Fragment, useEffect } from "react";
import StartStyle from "./start.style";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import LanguageSelect from "./LanguageSelect/LanguageSelect";
import CountrySelect from "./CountrySelect/CountrySelect";
import FormPortal from "./FormCountries/FormPortal";
import Cookies from "universal-cookie";
import Hidden from "@material-ui/core/Hidden";
import UnicityImge from "Assets/svg/UnicityLogo.svg";
import Button from "@material-ui/core/Button";
import FamilyImage from "Common/Images/family.png";
import ToggleDisplay from "Common/ToggleDisplay";
import SignUpSuccess from "Components/SignUpSuccessContainer/SignUpSuccessContainer";
import Faq from "./Faq";
import MemberProgram from "./MemberProgram";
import T, { translate } from "Translate";
import { useTheme } from "@material-ui/styles";
import { unstable_useMediaQuery as useMediaQuery } from "@material-ui/core/useMediaQuery";
import { hasTranslate } from "Utils/locale";
import MarketsSvc from "Services/markets/marketsSvc";
import sendEvent, { EVENT } from "Services/googleAnalytics";
import { Helmet } from "react-helmet";
import { datadogRum } from "@datadog/browser-rum";
import pkgJson from "../../../package.json";
import TechnicalDifficultyBanner from "./TechnicalDifficultyBanner";
import MaintenanceBanner from "./MaintenanceBanner";

const env = process.env.PUBLIC_URL.includes("dev") ? "dev" : "prod";

datadogRum.init({
    applicationId: process.env.DD_APP_ID,
    clientToken: process.env.DD_TOKEN,
    site: "us5.datadoghq.com",
    service: "membership",
    env: env,
    version: pkgJson.version,
    sessionSampleRate: 100,
    premiumSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    trackFrustrations: true
});

datadogRum.startSessionReplayRecording();

const Start = props => {
    const { classes, ...others } = props;
    const languageSelected = props.language ? props.language : undefined;
    const countrySelected = props.country ? props.country : undefined;
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.up("md"));

    const cookies = new Cookies();
    let refId = cookies.get("refId");

    useEffect(() => {
        window._mfq.push(["setVariable", "country", countrySelected]);
        window._mfq.push(["setVariable", "language", languageSelected]);
    }, [languageSelected, countrySelected]);

    useEffect(() => {
        const sponsor = sessionStorage.getItem("sponsor");

        sendEvent(EVENT.VIRTUAL_PAGE_VIEW, {
            name: props.membershipID ? "congrats" : "start",
            user_country: countrySelected,
            user_language: languageSelected,
            referral_id: refId || sponsor || null
        });
    }, [props.membershipID, languageSelected, countrySelected]);

    if (!hasTranslate()) return null;

    return (
        <Fragment>
            <Helmet>
                <title>{translate("start_title_tag")}</title>
                <meta name="description" content={translate("start_description_tag")} />
            </Helmet>

            <div className={classes.root} style={{ direction: MarketsSvc.isRTL(props.language) ? "rtl" : "ltr" }}>
                <Grid container direction="row" justify="center">
                    <MaintenanceBanner 
                        currentMarket={countrySelected}
                    />
                    <TechnicalDifficultyBanner 
                        currentMarket={countrySelected}
                    />
                    <Grid item xs={12}>
                        <div className={classes.header}>
                            <img alt="Unicity Main" src={UnicityImge} className={classes.headerImg} />
                            <div className={classes.regionSetting}>
                                {props.langOptions !== null && (
                                    <LanguageSelect
                                        languages={props.langOptions}
                                        selectedLanguage={languageSelected}
                                        onChange={language => props.updateLanguage(language)}
                                    />
                                )}
                                {props.markets !== null && (
                                    <CountrySelect
                                        markets={props.markets}
                                        selectedCountry={countrySelected}
                                        onLanguageChange={language => props.updateLanguage(language)}
                                        onCountryChange={country => props.updateCountry(country)}
                                        onCountryAndLanguageChange={(country, language) =>
                                            props.updateCountryAndLanguage(country, language)
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    </Grid>

                    {/*---Start pages starts---*/}
                    <ToggleDisplay if={!props.membershipID}>
                        <Grid item xs={12} className={classes.starter}>
                            <Grid container direction="row-reverse" justify="center" style={{ gap: "30px" }}>
                                <Hidden mdUp>
                                    <Grid item xs={12}>
                                        <div className={classes.umpHeader}>
                                            <T>ump_header</T>
                                        </div>
                                    </Grid>
                                </Hidden>
                                <Grid item xs={12} md={6}>
                                    <div className={classes.becameMember} data-testid="become_a_member_form">
                                        <Grid container direction="row" justify="center">
                                            <Grid item xs={12}>
                                                <div className={classes.bmHeaderText} data-testid="form_title">
                                                    <T>become_a</T>{" "}
                                                    {languageSelected !== "th" && (
                                                        <span className="member">
                                                            <T>member</T>
                                                        </span>
                                                    )}
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormPortal {...others} country={countrySelected} />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <MemberProgram />
                                </Grid>
                            </Grid>
                        </Grid>
                    </ToggleDisplay>
                    {/*---Start pages starts---*/}

                    {/*----Success page starts---*/}
                    <ToggleDisplay if={props.membershipID}>
                        <Helmet>
                            <title>{translate("success_title_tag")}</title>
                            <meta name="description" content={translate("success_description_tag")} />
                        </Helmet>
                        <div className={classes.starterSuccess}>
                            <div className={classes.successContainer} data-testid="success_section">
                                {md ? (
                                    <Grid container direction="row" justify="center">
                                        <Grid item sm={12} md={6} style={{ overflow: "hidden" }}>
                                            <div className={classes.successHeader} data-testid="success_title">
                                                <T>ump_header</T>
                                            </div>
                                            <div className={classes.familyBG}>
                                                <img src={FamilyImage} alt="" />
                                            </div>
                                        </Grid>
                                        <Grid item sm={12} md={6}>
                                            <SignUpSuccess />
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Fragment>
                                        <div className={classes.successHeader} data-testid="success_title">
                                            <T>ump_header</T>
                                        </div>
                                        <SignUpSuccess />
                                        <div className={classes.familyBG} style={{ overflow: "hidden" }}>
                                            <img src={FamilyImage} alt="" />
                                        </div>
                                    </Fragment>
                                )}
                            </div>
                        </div>
                    </ToggleDisplay>
                    {/*----Success page ends---*/}

                    <Grid item xs={12}>
                        {props.locale && props.locale.country && <Faq locale={props.locale} />}
                    </Grid>
                    <ToggleDisplay if={!props.membershipID}>
                        <Grid item xs={12}>
                            <Grid container direction="row" align="center" className={classes.footer} data-testid="footer">
                                <Grid item xs={12} className={classes.footerContent} data-testid="footer_content">
                                    <T>footer_content</T>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        className={classes.footerButton}
                                        onClick={() => window.scrollTo(0, 0)}
                                        data-testid="footer_button"
                                    >
                                        <T>join_now</T>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </ToggleDisplay>
                </Grid>
            </div>
        </Fragment>
    );
};

export default withStyles(StartStyle)(Start);



// WEBPACK FOOTER //
// ./src/components/StartContainer/Start.js